define([
	"dojo/_base/declare",
	"csi/action/NewController"
], function(declare,NewController) {

    return declare(NewController, {
		_canNavigate: function() {
			// summary: disallow Save & Go in this case
			return false;
		}
    });
});